// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

import "@hotwired/turbo-rails"

// BUGFIX: Turbo's PageObserver misses readyState="interactive" when starting late
// Deferred scripts execute after DOMContentLoaded, so Turbo starts when readyState
// is already "interactive". PageObserver only listens for future readystatechange
// events and doesn't check current state, causing it to wait for "complete" (after
// images load). Manually triggering readystatechange allows PageObserver to catch
// the current state and fire turbo:load immediately.
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  setTimeout(() => document.dispatchEvent(new Event('readystatechange')), 0);
}

import { BridgeElement } from "@hotwired/hotwire-native-bridge"
window.BridgeElement = BridgeElement

import "controllers"

// https://stackoverflow.com/questions/70921317/how-can-i-disable-hotwire-turbo-the-turbolinks-replacement-for-all-forms-in
// Turbo.session.drive = false
Turbo.config.forms.mode = "optin"